import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Svg from 'components/UI/Svg/Svg';
import {
  dfdDefaultTheme,
  CursorMuiBox,
  MuiBox,
  MuiButton,
  MuiDialog,
  MuiTypography
} from 'theme/material-ui';

import { eVisitNotInUtahDialogConstants } from 'lib/triage/constants';

import { Color } from 'modules/styles/colors';
import { FontSize, FontWeight, IconSize, Spacing, ZIndex } from 'modules/styles/variables';

import { TRIAGE_ROUTES } from 'screens/TriageGyant/constants';

export interface Props {
  handleClose: Function;
  isOpen: boolean;
  resultsCaseId: string;
}

const CloseButton = styled(CursorMuiBox)`
  position: absolute;
  top: ${Spacing.large}px;
  right: ${Spacing.large}px;
  z-index: ${ZIndex.high};
`;

export const EVisitsNotInUtahDialog = ({ handleClose, isOpen, resultsCaseId }: Props) => {
  const fullScreen = useMediaQuery(dfdDefaultTheme.breakpoints.down('sm'));
  const history = useHistory();

  const handleGoBackToCareOptionsClick = () => {
    handleClose();
    history.push(`${TRIAGE_ROUTES.RESULTS.BASE_URL}/${resultsCaseId}`);
  };

  return (
    <MuiDialog fullScreen={fullScreen} maxWidth="sm" open={isOpen} onClose={() => handleClose()}>
      <MuiBox p={3} py={2}>
        <CloseButton
          onClick={() => handleClose()}
          data-testid="evisits-not-in-utah-dialog-close-button"
        >
          <Svg name="close" size={IconSize.base} set="material" color={Color.black} />
        </CloseButton>
        <MuiBox display="flex" justifyContent="center" py={1}>
          <Svg set="assets" size={IconSize.xLarge} color={Color.primary} name="ExclamationCircle" />
        </MuiBox>
        <MuiBox display="flex" justifyContent="center" py={2}>
          <MuiTypography
            align="center"
            fontSize={FontSize.heading}
            fontWeight={FontWeight.semibold}
          >
            {eVisitNotInUtahDialogConstants.dialogTitleText}
          </MuiTypography>
        </MuiBox>
        <MuiBox display="flex" py={1}>
          <MuiTypography align="center" fontSize={FontSize.heading}>
            {eVisitNotInUtahDialogConstants.dialogContentText}
          </MuiTypography>
        </MuiBox>
        <MuiBox display="flex" py={1}>
          <MuiButton
            fullWidth
            disableRipple
            variant="contained"
            color="primary"
            size="large"
            onClick={handleGoBackToCareOptionsClick}
            data-testid="evisits-go-back-to-care-options-button"
          >
            {eVisitNotInUtahDialogConstants.dialogButtonText}
          </MuiButton>
        </MuiBox>
      </MuiBox>
    </MuiDialog>
  );
};

export default EVisitsNotInUtahDialog;
